import _ from 'lodash'
import Moment from 'moment'
import { addNotification, removeNotification } from 'src/vuex/actions'
import { skins, forms, config } from 'src/vuex/getters'

export default {
  data () {
    return {
      formInput: false,
      complete: false,
      uid: this.$parent.uid,
      error: false,
      errors: null,
      attempts: 0
    }
  },
  props: {
    dispatch: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Boolean,
      default: true
    },
    idx: {
      type: Number,
      default: 0
    }
  },
  vuex: {
    getters: {
      skins,
      forms,
      config
    },
    actions: {
      addNotification,
      removeNotification
    }
  },
  computed: {
    required () {
      return _.some(this.fdata.validation, ['rule', 'required']) || this.$parent.mandatory
    }
  },
  filters: {
    format (str) {
      /* eslint-disable no-useless-escape */
      if (/^((31(?!\ (Feb(ruary)?|Apr(il)?|June?|(Sep(?=\b|t)t?|Nov)(ember)?)))|((30|29)(?!\ Feb(ruary)?))|(29(?=\ Feb(ruary)?\ (((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)))))|(0?[1-9])|1\d|2[0-8])\ (Jan(uary)?|Feb(ruary)?|Ma(r(ch)?|y)|Apr(il)?|Ju((ly?)|(ne?))|Aug(ust)?|Oct(ober)?|(Sep(?=\b|t)t?|Nov|Dec)(ember)?)\ ((1[6-9]|[2-9]\d)\d{2})$/.test(str)) {
        let date = Moment(str)
        return date._isValid ? Moment(str).format('DD/MM/YYYY') : str
      } else {
        return str
      }
    }
  },
  events: {
    'clear': 'reset',
    'set': 'insert',
    'force::validate' () {
      this.attempts = 1
      this.validate()
      return true
    },
    'external::error' (errors) {
      if (!_.isUndefined(errors[this.fdata.field])) {
        this.$set('error', !_.isNull(errors[this.fdata.field]))
      }
      return true
    },
    'parent::errors' (errors) {
      if (_.has(errors, this.fdata.field)) {
        this.$set('errors', errors[this.fdata.field])
      }
      return true
    }
  },

  methods: {
    reset () {
      this.$set('formInput', '')
      return true
    },

    insert (data) {
      var value
      if (_.isArray(data)) {
        let input = _.find(data, ['field', this.fdata.field])
        value = input ? input.value : ''
      } else {
        value = data[this.fdata.field] || ''
      }
      this.$set('formInput', value)
      return true
    },

    validate () {
      if (!this.validation) return this.dispatch()
      let validated = this.computedValidate(this.fdata, this.formInput)
      this.fieldState(validated)
      if (this.config.inlineErrors && _.gt(this.attempts, 0)) {
        this.$set('errors', validated)
      }
      this.notice('error', validated)
    },
    notice (type, valid) {
      _.isNil(valid) || _.isEmpty(valid)
        ? this.removeNotification(this.fdata.field)
        : this.addNotification({
          type: type,
          msg: valid,
          id: this.fdata.field,
          show: this.config.inlineErrors ? false : _.gt(this.attempts, 0)
        })

      this.dispatch()
    },

    fieldState (valid) {
      if (this.attempts < 1) return false
      _.isNil(valid) ? this.setFieldComplete() : this.setFieldError()
    },

    setFieldComplete () {
      this.$set('complete', true)
      this.$set('error', false)
    },

    setFieldError () {
      this.$set('error', true)
      this.$set('complete', false)
    },

    dispatch () {
      if (this.fdata.field && this.fdata.editable) {
        this.$dispatch('fdata::input',
                       {[this.fdata.field]: this.formInput},
                       this.idx)
      }
    }
  },

  ready () {
    if (this.fdata.errors !== undefined &&
        this.fdata.errors.length) {
      this.fdata.errors.forEach(x => {
        this.addNotification({type: 'error',
                              msg: [x],
                              id: _.uniqueId(),
                              timeout: 6000,
                              onComplete: 'remove',
                              show: true})
      })
    }
    this.formInput = this.fdata.value
    if (!_.includes(['TypeMultipart'], this._context.constructor.name)) {
      let vuex = _.find(this.forms, ['uid', this.uid])
      if (vuex) {
        let formData = vuex.data[this.fdata.field]
        if (formData && !_.isArray(formData)) {
          this.formInput = formData
        }
      }
    }
    if (this.validation) this.validate()
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/_shared/traits.js